import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Header from './Header.jsx';
import styles from "./Followers.module.css"
import defaultPicture from "../assets/default_pfp.png";
import translations from "./translation.js";

const Blocked = () => {
  const [connections, setConnections] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(null);
  const { userID } = useParams();
  const loggedIn = sessionStorage.getItem("user");
  const loggedInUserID = sessionStorage.getItem("user");
  const currentLanguage = localStorage.getItem('selectedLanguage') || "en";



  useEffect(() => {
    loadBlocks();
  }, []);

  const loadBlocks = () => {
    fetch(
      process.env.REACT_APP_API_PATH +
      "/connections?fromUserID=" + userID,
      {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + sessionStorage.getItem("token"),
        },

      }
    )
      .then(res => res.json())
      .then(data => {
        const allowedConnections = [-3, 3];
        const newConnections = [];
        for (let i = 0; i < Object.keys(data[0]).length; i++) {
          if (data[0][i].attributes.connection && allowedConnections.includes(data[0][i].attributes.connection)) {
            newConnections.push({
              username: data[0][i].toUser.attributes.username,
              picture: data[0][i].toUser.attributes.picture || defaultPicture,
              id: data[0][i].toUser.id,
              connection: data[0][i].attributes.connection
            });
          }
        }
        setConnections(newConnections);
        setIsLoaded(true);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  };

  return (
    <div className={styles.bg}>
      <Header />
      <div className={styles.navContainer}>
        <Link to={`/user/${userID}/following`}><button className={styles.navBtn}>{translations[currentLanguage].following}</button></Link>
        <Link to={`/user/${userID}/followers`}><button className={styles.navBtn}>{translations[currentLanguage].followers}</button></Link>
        <Link to={`/user/${userID}/blocked`}><button className={styles.currBtn}>{translations[currentLanguage].blocked}</button></Link>
        <Link to={`/user/${userID}/requests`}><button className={styles.navBtn}>{translations[currentLanguage].requests}</button></Link>
      </div>
      <div className={styles.connectionsContainer}>
        {isLoaded ? (
          connections.map((connection, index) => (
            <Link to={`/user/${connection.id}`} className="connection-pic">
              <div key={index} className={styles.connectionItem}>
                <img src={connection.picture} alt="user avatar" />
                <span>{connection.username}</span>
                <button>{connection.connection == 3 ? "BLOCKING" : "BLOCKED"}</button>
              </div>
            </Link>
          ))
        ) : (
          <p>Loading...</p>
        )}
        {error && <p>Error: {error.message}</p>}
      </div>
    </div>
  );
}

export default Blocked;
